import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  styled,
  tableCellClasses,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { resizeImage } from '../../api/cloudinary';
import { Player } from '../room/types';
import { isGif, transformCloudinaryGifToStill } from '../room/utils';

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.root}`]: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: '2px',
    maxWidth: '150px',
  },
}));

type PropTypes = {
  players: Player[];
};

export const Leaderboard = ({ players }: PropTypes) => {
  return (
    <>
      <Typography variant="h5" mb={2}>
        Leaderboard
      </Typography>
      <TableContainer component={Paper}>
        <Table stickyHeader size="small" aria-label="sticky table">
          <TableHead>
            <TableRow>
              <StyledTableCell width={'5%'}></StyledTableCell>
              <StyledTableCell width={'5%'}></StyledTableCell>
              <StyledTableCell width={'70%'}>Username</StyledTableCell>
              <StyledTableCell width={'10%'}>Score</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {players?.map((p, i) => (
              <TableRow key={p.username}>
                <StyledTableCell>{i + 1}.</StyledTableCell>
                <StyledTableCell>
                  <Avatar
                    src={
                      isGif(p.avatarUrl)
                        ? transformCloudinaryGifToStill(p.avatarUrl)
                        : resizeImage(p.avatarPublicId, 50, 50)
                    }
                    variant="rounded"
                    sx={{ height: 30, width: 30 }}
                  >
                    {!p.avatarUrl ? p.username.charAt(0) : null}
                  </Avatar>
                </StyledTableCell>
                <StyledTableCell>{p.username}</StyledTableCell>
                <StyledTableCell>
                  {p.parScore > 0 ? '+' : ''}
                  {p.parScore}
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
